import React, { useEffect } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
import Footer from './root/Footer';
import Navbar from './root/Navbar';



function Layout(props) {
    useEffect(() => {
        AOS.init();
        AOS.refresh();
    }, []);
    return (
        <div>
            <div style={{ backgroundColor: "White" }}>
                <Navbar />
                {props.children}
                <Footer />
            </div>
        </div>
    );
}

export default Layout;